import PersonalizationTag from '../../components/onboarding/PersonalizationTag'
import { useAppSelector } from '../../hooks/hooks'
import { t } from '../../utilities/translator';
import { transformPreferences } from '../wizard-v2/steps/personalizationSteps/helpers';

type Props = {
  text: string;
}

const PersonalizedTitle = ({ text }: Props) => {
  const user = useAppSelector(state => state.user);
  const preferences = user.preferences ? transformPreferences(user.preferences, user.searchProfile?.id) : null;

  const renderUserPreferences = () => {
    return (
      <div className="flex flex-wrap lg:justify-end gap-2">
        {preferences && Object.keys(preferences).map(group => preferences[group].map(item => {
          if (item.name === 'facilities') {
            return null;
          }

          return (
            <PersonalizationTag
              key={item.question_id}
              text={item.translation}
              size="small"
              active
            />
          )
        }))}
      </div>
    )
  }

  return (
    <div className='personalized-deals-title text-start'>
      <div>
        <div className="text-2xl font-semibold leading-none" dangerouslySetInnerHTML={{ __html: text }} />
        <div className="font-medium">{t('app.personalizedFeed')}</div>
      </div>
      <div>
        {renderUserPreferences()}
      </div>
    </div>
  )
}

export default PersonalizedTitle
